import { Address, encodeAbiParameters, keccak256, parseAbiParameters, toHex } from "viem";

export function buildCancelBetSigPayload({
	chain_id,
	contract_address,
	bet_owner,
	bet_onchain_id,
	picks,
	deadline_ts,
	wallet_nonce,
}: {
	chain_id: number;
	contract_address: string;
	bet_owner: string;
	bet_onchain_id: string;
	picks: { event_market_onchain_id: string; outcome_onchain_id: string }[];
	deadline_ts: number;
	wallet_nonce: number;
}) {
	const hash_abi = "bytes32, uint256, address, address, uint256, (bytes12,bytes12)[], uint256, uint256";
	const encoded_message = encodeAbiParameters(
		parseAbiParameters(hash_abi),
		[
			keccak256(toHex("cancelBet")),
			BigInt(chain_id),
			contract_address as Address,
			bet_owner as Address,
			BigInt(bet_onchain_id),
			picks.map(p => [p.event_market_onchain_id as Address, p.outcome_onchain_id as Address] as const),
			BigInt(deadline_ts),
			BigInt(wallet_nonce),
		],
	);
	return keccak256(encoded_message);
}
